import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import axios from "axios";
import { csvParse } from "d3-dsv";

const ScatterPlot = ({
  cordZcutoff,
  cordX,
  cordY,
  cordZ,
  dataType,
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        `https://raw.githubusercontent.com/jheonii/compass_db/main/3d_scatter_${dataType}.csv`
      );
      const rows = csvParse(response.data);
      const unpack = (rows, key) => rows.map((row) => row[key]);

      const trace1 = {
        x: unpack(rows, "x1"),
        y: unpack(rows, "y1"),
        z: unpack(rows, "z1"),
        mode: "markers",
        marker: {
          color: "#4343439b",
          size: 2,
          line: {
            color: "#f0f5f7",
            width: 0.9,
          },
          opacity: 0.4,
        },
        type: "scatter3d",
        showlegend: false,
      };

      const trace2 = {
        x: [cordX],
        y: [cordY],
        z: [cordZ],
        mode: "markers+text",
        marker: {
          color: "red",
          size: 5,
          symbol: "circle",
          line: {
            color: "rgb(204, 204, 204)",
            width: 1,
          },
          opacity: 0.7,
        },
        type: "scatter3d",
        text: ["User Input"], // Text to display
        textfont: {
          color: "red", // Color for text
          size : 15
        },
        textposition: "top center", // Text position
        showlegend: false,
      };

      const trace3 = {
        x: [cordX],
        y: [cordY],
        z: [cordZcutoff],
        mode: "markers+text",
        marker: {
          color: "blue",
          size: 5,
          symbol: "circle",
          line: {
            color: "rgb(204, 204, 204)",
            width: 1,
          },
          opacity: 0.7,
        },
        type: "scatter3d",
        text: ["Cut off"], // Text to display
        textfont: {
          color: "blue", // Color for text
          size : 15
        },
        textposition: "top center", // Text position
        showlegend: false,
      };

      const trace2Lines = [
        {
          // y-axis line
          x: [cordX, cordX],
          y: [cordY, cordY],
          z: [0, cordZ],
          mode: "lines",
          line: { color: "#565b57", width: 5 },
          type: "scatter3d",
          showlegend: false,
        },
        {
          // x-axis line
          x: [cordX, cordX],
          y: [cordY, 2500],
          z: [0, 0],
          mode: "lines",
          line: { color: "#565b57", width: 5 },
          type: "scatter3d",
          showlegend: false,
        },
        {
          // z-axis line
          x: [cordX, 2500],
          y: [cordY, cordY],
          z: [0, 0],
          mode: "lines",
          line: { color: "#565b57", width: 5 },
          type: "scatter3d",
          showlegend: false,
        },
      ];

      setData([...trace2Lines, trace1, trace2, trace3]);
    };
    fetchData();
  }, [cordZcutoff,
    cordZ,
    cordY,
    cordX,
    dataType]);

  const layout = {
    margin: {
      l: 60,
      r: 0,
      b: 0,
      t: 0,
    },
    width: 990,
    height: 750,
    scene: { // add scene object
      xaxis: {
        title: 'Pathway (Gene set size)' // title for X Axis
      },
      yaxis: {
        title: 'User Input (Gene set size)' // title for Y Axis
      },
      zaxis: {
        title: '-log10(P-value)' // title for Z Axis
      }
    },
  };

  return <Plot data={data} layout={layout} />;
};

export default ScatterPlot;
